/**
 * @internal
 */
export var ProductTypeUrlSuffix = {
    Family: 'family',
    Group: 'groups',
    Product: 'products',
};
